import PropTypes from 'prop-types';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import Button from 'Components/Atoms/Button/Button';
import Icon from 'Components/Atoms/Icon/Icon';
import SnackbarCard from './SnackbarCard';
import SnackbarLayout from './SnackbarLayout';
import SnackbarContent from './SnackbarContent';
import SnackbarActionText from './SnackbarActionText';
import SnackbarTitle from './SnackbarTitle';
import SnackbarAction from './SnackbarAction';

export default function SnackbarUploadSuccess({ id, message }) {
    const { t } = useTranslation('common');

    return (
        <SnackbarCard>
            <SnackbarLayout>
                <div className="shrink-0">
                    <div className="bg-success text-white size-6 rounded-full flex items-center justify-center">
                        <Icon name="check" size={12} color="currentColor" />
                    </div>
                </div>
                <SnackbarContent>
                    <SnackbarActionText>{t('uploaded')}</SnackbarActionText>
                    <SnackbarTitle>{message}</SnackbarTitle>
                </SnackbarContent>
                <SnackbarAction>
                    <Button size="small" variant="primary" onClick={() => toast.dismiss(id)}>
                        {t('accept')}
                    </Button>
                </SnackbarAction>
            </SnackbarLayout>
        </SnackbarCard>
    );
}

SnackbarUploadSuccess.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    message: PropTypes.string.isRequired,
};
